document.addEventListener("DOMContentLoaded", function () {
  var seSwiper = new Swiper('.se-split-swiper', {
    direction: 'horizontal',
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const thumbElements = document.querySelectorAll(".product-area__details__thumbs__thumb");

  thumbElements.forEach((thumb, index) => {
    thumb.addEventListener("click", function (e) {
      e.preventDefault();
      seSwiper.slideTo(index+1);
    });
  });
  
}, false);